import React from 'react';
import ReactDOM from 'react-dom';
import { App } from './app/components/app';
import { registerSW, showRefreshUI } from './sw-register';
import { initializeApp } from 'firebase/app';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { getFirestore, collection, doc, getDoc } from 'firebase/firestore';

const registeredSW = (window.location.host.includes('localhost') || window.location.host.includes('127.0.0.1')) ? 
  new Promise(() => {
    //
  }) : registerSW();

const getConfig = () => {
  if (window.location.host.includes('localhost') || window.location.host.includes('githubpreview.dev')) {
    return Promise.resolve({
      apiKey: 'AIzaSyAotdsMoX6VPA2hi4MGYh7tkAUjELqgYUE',
      appId: '1:1031950417701:web:d491d7dc27c67bac',
      authDomain: 'jurisopus.firebaseapp.com',
      databaseURL: 'https://jurisopus.firebaseio.com',
      messagingSenderId: '1031950417701',
      projectId: 'jurisopus',
      storageBucket: 'jurisopus.appspot.com',
    });
  }

  return fetch('/__/firebase/init.json').then((response) => response.json());
};

const fetchCurrentUser = (auth) =>
  new Promise((resolve) => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      unsubscribe();
      resolve(user);
    });
  });

const getCurrentUser = (auth, db) =>
  Promise.resolve(auth.currentUser)
    .then((user) => user || fetchCurrentUser(auth))
    .then((user) => {
      if (!user) {
        return null;
      }

      return getDoc(doc(db, 'users', user.uid))
        .then((userDoc) => {
          const data = userDoc.data();
          return {
            uid: user.uid,
            displayName: user.displayName,
            email: user.email,
            role: data.role,
            org: data.org,
          };
        });
    });

getConfig()
  .then((firebaseConfig) => {
    const app = initializeApp(firebaseConfig);
    const auth = getAuth(app);
    const db = getFirestore(app);

    // Create compatibility layer for existing code
    window.firebase = {
      auth: () => auth,
      firestore: () => db,
    };

    return getCurrentUser(auth, db);
  })
  .then((user) => {
    ReactDOM.render(<App user={user} />, document.getElementById('root'));
    registeredSW.then(showRefreshUI);
  })
  .catch((e) => {
    console.log(e.message);
  });
